// The empty form shape for the Fulfill request page; its enums are shared (components/common).
import { EMPTY_LIST } from '@/lib/utils';

export const EMPTY_FULFILL_SHIPMENT_FORM = Object.freeze({
  facilityId: '',
  terminalId: '',
  vesselName: '',
  retireCredits: '',
  // The picked order — the design calls this section "Order selection".
  pendingOrderId: '',
  // Written by <SelectFromTable> via setValue, never a rendered control of its own.
  selectedInbounds: EMPTY_LIST,
  fulfillUnitType: '',
  hasMixedUnitBatches: false,
});
